import _ from 'lodash';
import styles from './RequestThumbnailCardUI.module.scss';
import { Col, Row } from 'react-bootstrap';
import cx from 'classnames';
import { BigButton, Image, Loader } from '../../../common';
import icons from '../../../assets';
import ReactTimeAgo from 'react-time-ago';
import { REQUEST_STATUSES, STATUS, THUMBNAIL_CARD_DATE_FORMAT } from '../../../constants/constants';
import { MemberThumbnail } from '../../../common/ThumbnailCardUI';
import { ElipsisTooltip } from '../../../common/ElipsisTooltip';
import moment from 'moment';

const RequestThumbnailCardUI = ({
  list,
  selected,
  onCardClick,
  loading,
  deleteLoading,
  size = 4,
  showSelectedText,
  style = {},
  noDataText = 'No data found.',
  onDeleteClick,
  showDataInfo = false,
  showStatusTag,
}) => {
  const { DeleteIcon, RequestImageIcon } = icons;

  const checkIsExpired = (item) => item?.isPurchased && !item?.is_used && item?.is_expiry;

  const handleClick = (_item) => {
    if (checkIsExpired(_item)) return;
    onCardClick(_item);
  };

  const getStatusColor = (status) => STATUS.find((_item) => _item.value === status)?.color;

  return (
    <Row>
      {list.length ? (
        list.map((item) => {
          const isExpiredCard = checkIsExpired(item);
          return (
            <Col md={size} key={item.id} className={styles.wrapper} style={style}>
              {/* {checkIfImage(item.thumbnail) ? ( */}
              <div
                className={cx(
                  styles.imageBox,
                  selected === item.id || (Array.isArray(selected) && selected?.includes(item.id))
                    ? styles.selected
                    : '',
                  'w-100'
                )}>
                {(selected === item.id ||
                  (Array.isArray(selected) && selected?.includes(item.id))) &&
                  showSelectedText && <div className={styles.selectedText}>Selected</div>}

                {showStatusTag && item?.model_request?.status && (
                  <>
                    <div
                      className={styles.statusTag}
                      style={{
                        background: isExpiredCard
                          ? '#555'
                          : getStatusColor(item?.model_request?.status),
                      }}>
                      {isExpiredCard
                        ? 'EXPIRED'
                        : item?.model_request?.status?.replaceAll('_', ' ')}
                    </div>
                    {item?.unread_count > 0 ? (
                      <ElipsisTooltip
                        title={`You have ${item?.unread_count} new message${
                          item?.unread_count > 1 ? 's' : ''
                        }.`}
                        alwaysShow={true}>
                        {({ ref, onMouseEnter, onMouseLeave }) => (
                          <div
                            className={styles.unread_count}
                            ref={ref}
                            onMouseEnter={onMouseEnter}
                            onMouseLeave={onMouseLeave}></div>
                        )}
                      </ElipsisTooltip>
                    ) : null}
                  </>
                )}

                <div
                  className={styles.mainRequest}
                  onClick={() => handleClick(item)}
                  style={{ cursor: isExpiredCard ? 'default' : 'pointer', position: 'relative' }}>
                  <>
                    <Image
                      src={item.thumbnail}
                      placeholderWhileLoading
                      hideWithNoSrc
                      ratio={1.5}
                      Icon={RequestImageIcon}
                      placeholderColor="#EAEAEA"
                      style={{ borderRadius: '2px !important' }}
                      containerProps={{ className: styles.imageRoot }}
                    />
                    {item?.isPurchased && !isExpiredCard ? (
                      <div className={styles.purchasedRequest}>
                        <BigButton
                          className="lf-btn-1"
                          buttonTitle="Complete Request"
                          title="Complete Request"
                        />
                      </div>
                    ) : null}
                  </>
                </div>

                {item.isPurchased && (
                  <div className={cx('d-flex flex-column gap-1', styles.title)}>
                    <span onClick={() => handleClick(item)}>{item.title}</span>
                    <span style={{ fontSize: '13px', color: 'var(--dark-300)' }}>
                      {item.product_name}
                    </span>
                  </div>
                )}

                {!item.isPurchased && (item.name || item.owner_organization_details) && (
                  <div className={cx('d-flex flex-column gap-1', styles.title)}>
                    <span onClick={() => handleClick(item)}>{item.name}</span>
                    {showDataInfo ? (
                      <div className={styles.dataInfo}>
                        <MemberThumbnail user={item?.model_request?.created_by} />
                        <div className={styles.itemInfo}>
                          <div className={styles.fileName}>{item?.filename}</div>
                          {item?.model_request?.created_at ? (
                            <div className={styles.uploadDate}>
                              {/* <ReactTimeAgo date={item?.model_request?.created_at} /> */}
                              {moment(item?.model_request?.created_at).local().format(THUMBNAIL_CARD_DATE_FORMAT)}
                            </div>
                          ) : null}
                        </div>
                        <div></div>
                      </div>
                    ) : null}
                  </div>
                )}

                {onDeleteClick && item.model_request.status === REQUEST_STATUSES.DRAFT.value && (
                  <div
                    className={styles.deleteIcon}
                    onClick={(e) => onDeleteClick(e, item.id, item)}>
                    {deleteLoading[item.id] ? (
                      <div className={styles.loader}>
                        <Loader loading size={18} thickness={2} />
                      </div>
                    ) : (
                      <DeleteIcon />
                    )}
                  </div>
                )}
              </div>
              {/* )  */}
              {/* // : (
              //   <div className={cx(styles.showExtension, styles.imageBox)}>
              //     {item?.filename?.split('.').at(-1)?.toUpperCase()}
              //   </div>
              // )} */}
            </Col>
          );
        })
      ) : (
        <>
          {!loading && noDataText && <h3 className={cx(styles.mutedText, 'py-3')}>{noDataText}</h3>}
        </>
      )}
    </Row>
  );
};
export default RequestThumbnailCardUI;
